var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PersonalAttendanceMonthlyPageTable',{attrs:{"reload":_vm.reload}})
}
var staticRenderFns = []

export { render, staticRenderFns }